module.exports = __webpack_public_path__ + "static/assets/8764c2a084cdbb59327bf1ea06c0d8dd.svg";